import { buildProps, definePropType } from "@xplus/utils/props";
import type { ExtractPropTypes, Component } from "vue";
export interface StepItem {
  title: string;
  desc?: string;
  slot?: string;
  icon?: string | Component;
}
export const stepProps = buildProps({
  title: {
    type: String,
    required: true,
  },
  desc: {
    type: String,
  },
  slotName: {
    type: String,
  },
  icon: {
    type: definePropType<string | Component>([String, Object]),
  },
} as const);

export type StepProps = ExtractPropTypes<typeof stepProps>;
